import { sharedLib } from "@shared/services/shared.service";
import { updateAndGetUtmData } from "@shared/utils/misc";
import useQuery from "utils/hooks/useQuery";
import { useEffect, useMemo, useState } from "react";
import { MarkVisitRequest, UtmData, UtmParams } from "@shared/types";
import { omit } from "lodash";
import { LOCAL_STORAGE_UTM_DATA_KEY } from "@shared/common/constants";
import { useRouteMatch } from "react-router-dom";
import { REGISTER_PATH } from "common/constants.ts";

export const useUtmMarkVisit = () => {
  const query = useQuery();
  const queryParams = useMemo(() => Object.fromEntries(query), [query]);
  const [markVisit] = sharedLib.sharedApi.authentication.useMarkVisitMutation();
  const [utmData, setUtmData] = useState<UtmData>();

  useEffect(() => {
    updateAndGetUtmData(queryParams).then((utmData) => {
      if (utmData) {
        setUtmData(utmData);
        let args: MarkVisitRequest = { ...utmData, click_id: utmData.gclid };
        args = omit(args, UtmParams.GCLID);
        markVisit(args).then((response) => {
          if (response?.error?.status === 404) {
            localStorage?.setItem(LOCAL_STORAGE_UTM_DATA_KEY, "");
          }
        });
      }
    });
  }, []);

  return {
    utmData,
  };
};

export const useReferralCode = () => {
  const query = useQuery();
  const referralCodeParam = useRouteMatch<{ referralCode: string }>(
    REGISTER_PATH
  )?.params.referralCode;
  const referralCodeQuery = query.get("rcode") || undefined;

  return referralCodeParam || referralCodeQuery;
};
